<template>
  <div style="background-color: #fff">
    <titleBox
      name="关于旷真"
      imgUrl="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/abuout/title.png"
    ></titleBox>
    <van-tabs
      v-model="active"
      animated
      sticky
      swipeable
      :ellipsis="false"
      :swipe-threshold="4"
      @change="onTabChange"
    >
      <van-tab
        v-for="(item, index) in activeList"
        :title="item"
        :key="index"
        style="background-color: #fff"
      >
        <!-- 内容 {{ index }} -->
        <jianjie v-show="item == '旷真简介'"></jianjie>
        <memorabilia v-show="item == '旷真大事记'"></memorabilia>
        <culture v-show="item == '旷真文化'"></culture>
        <!-- <territory v-show="item == '旷真版图'"></territory> -->
        <viewpoint v-show="item == '旷真观点'"></viewpoint>
        <faq v-show="item == '常见问答'"></faq>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import titleBox from "../../components/titleBox/index";
import jianjie from "./jianjie.vue";
import memorabilia from "./memorabilia.vue";
import culture from "./culture.vue";
import territory from "./territory.vue";
import viewpoint from "./viewpoint.vue";
import faq from "./faq.vue";
export default {
  components: { titleBox, jianjie, memorabilia, culture, territory, viewpoint, faq },
  data() {
    return {
      active: 0,
      activeList: [
        "旷真简介",
        "旷真大事记",
        "旷真文化",
        "旷真观点",
        "常见问答",
        // "旷真版图",
      ],
      // "旷真架构",
    };
  },
  created() {
    this.applyTab();
  },
  watch: {
    "$route.query.tab"() {
      this.applyTab();
    },
  },
  methods: {
    applyTab() {
      const tab = this.$route.query.tab;
      if (tab === undefined || tab === null || tab === "") {
        this.active = 0;
        return;
      }
      const nameIndex = this.activeList.indexOf(String(tab));
      if (nameIndex >= 0) {
        this.active = nameIndex;
        return;
      }
      const index = Number(tab);
      if (!Number.isNaN(index) && index >= 0 && index < this.activeList.length) {
        this.active = index;
      }
    },
    onTabChange(index) {
      const name = this.activeList[index];
      const nextTab = index === 0 ? "" : name;
      const currentTab = this.$route.query.tab ? String(this.$route.query.tab) : "";
      if (nextTab === currentTab) {
        return;
      }
      this.$router.replace({
        path: "/about",
        query: nextTab ? { tab: nextTab } : {},
      }).catch(() => {});
    },
  },
};
</script>

<style>
.van-tab--active {
  color: #ab0000 !important;
}
.van-tabs__line {
  background-color: #ab0000 !important;
}
</style>
